<footer class="fc-footer">
  <div class="fc-logo"></div>
  <span class="fc-address">
    Default srl Viale Europa Unita 37, 24043 Caravaggio, Italy
  </span>
  <span class="fc-iva">P.IVA 04536920160</span>
  <span class="fc-email">info@default-solutions.it </span>
  <span class="fc-copywrite">&copy; Copyright 2023 Default srl</span>
</footer>
